import { Types } from './types';
import { action } from 'typesafe-actions';

export const setAppConnectivity = (online: boolean) =>
  action(Types.CONNECTIVITY_SET_CONNECTION, {
    online
  });
